function initialiseComponent() {
    setBaseUrl();

    return import(/* webpackChunkName: "app" */ './Miniapp')
        .then(({ default: app }) => {
            app();
        })
        .catch(error => `An error occurred while loading the component ${error}`);
}

function setBaseUrl() {
    const currentScript = document.getElementById('nab-calculator-loader');
    if (currentScript) {
        const SERVER_ADDRESS = currentScript.src.match(/^(.*)nab-calculator.js/)[1];
        // eslint-disable-next-line no-undef
        __webpack_public_path__ = SERVER_ADDRESS; // eslint-disable-line camelcase
    }
}
initialiseComponent();